import { Component, inject, OnInit } from '@angular/core';
import { RestStopService } from '../../services/rest-stop.service';
import { RestStop } from '../../models/rest-stop';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { DistancePipe } from '../../pipes/distance.pipe';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-search-results',
  standalone: true,
  imports: [
    CommonModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatIconModule,
    RouterModule,
    DistancePipe,
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
  ],
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss'],
})
export class SearchResultsComponent implements OnInit {
  isLoading = true;
  restStops: RestStop[] = [];
  error: string | null = null;

  private route = inject(ActivatedRoute);

  constructor(private restStopService: RestStopService) {}

  searchControl = new FormControl('');

  currentlySearching = false;

  ngOnInit(): void {
    this.loadNearestStops();

    this.route.queryParamMap.subscribe((params) => {
      const q = params.get('q');
      if (q) {
        this.searchControl.setValue(q);
        this.search(q);
      }
    });

    this.searchControl.valueChanges.pipe().subscribe((searchTerm) => {
      console.log('Search term changed:', searchTerm);
      if (searchTerm) {
        this.isLoading = true;
        this.search(searchTerm);
        this.currentlySearching = true;
      } else {
        this.currentlySearching = false;
        this.loadNearestStops();
      }
    });
  }

  private loadNearestStops(): void {
    this.isLoading = true;
    this.error = null;

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude, heading } = position.coords;
        this.restStopService.getNearestRestStops(latitude, longitude, heading).subscribe({
          next: (stops) => {
            this.restStops = stops;
            this.isLoading = false;
          },
          error: (err) => {
            console.error('Fehler beim Laden der nächsten Raststätten:', err);
            this.error = 'Die Raststätten konnten nicht geladen werden.';
            this.isLoading = false;
          },
        });
      },
      (geoError) => {
        console.warn('Standort konnte nicht abgerufen werden:', geoError.message);
        this.error = 'Dein Standort konnte nicht abgerufen werden. Bitte erteile die Freigabe.';
        this.isLoading = false;
      },
      { enableHighAccuracy: true },
    );
  }

  search(searchTerm: string) {
    this.restStopService.getRestStopBySearch(searchTerm).subscribe((rs) => {
      this.isLoading = true;
      this.error = null;
      this.restStops.splice(0, this.restStops.length, ...rs);
      this.isLoading = false;
    });
  }
}
